jQuery.feature_import("js-daymenuspecification-react",
  () => import("./DayMenuSpecification.js"),
  mod => mod.feature_js_daymenuspecification_react
);